import { useContext, useCallback } from "react";
import BryntumContext from "../../context/bryntumContext.jsx";
import { getViewStateIconByRecord } from "../../../other/utils/utils.jsx";
import { useRecentViews } from "../../context/recentViewsContext.jsx";

const RecentViewsQuickActions = () => {
  const { project, viewManager, entityManager } = useContext(BryntumContext);

  const { currentViews } = useRecentViews();
  const [_selectedView, ...recentViews] = currentViews;

  const handleViewSelect = useCallback(
    (item) => {
      const view = viewManager.getViewById(item.id);
      viewManager.selectView(view);
      if (entityManager.isOpen) {
        entityManager.closeEntityManager();
      }
    },
    [viewManager, entityManager]
  );

  if (recentViews.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-6 items-center ml-4">
      {recentViews.map((view) => {
        const iconClass = getViewStateIconByRecord(view, project);
        return (
          <button
            key={view.id}
            className="flex gap-2 items-center text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
            onClick={() => handleViewSelect(view)}
          >
            <i className={`${iconClass} text-base`} style={view.color ? { color: view.color } : undefined} />
            <span className="max-w-32 truncate">{view.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default RecentViewsQuickActions;
